import { Pipe, PipeTransform } from '@angular/core';
import { Title } from '@shared/components/title/model';

@Pipe({
  name: 'buildTitle',
  standalone: true,
})
export class BuildTitlePipe implements PipeTransform {
  transform(value: Title, newValue: Partial<Title>): Title[] {
    return [{ ...value, ...newValue }];
  }
}
